var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.splitValues, function (v, i) {
        return _c("div", { key: i, staticClass: "mb-1" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: _vm.type,
                placeholder: _vm.placeholder,
                pattern: _vm.pattern.source,
                "aria-describedby": "button-addon_" + i,
              },
              domProps: { value: v },
              on: {
                input: function ($event) {
                  return _vm.updateValue(i, $event.target)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "input-group-append",
                attrs: { id: "button-addon_" + i },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.doRemove(i)
                      },
                    },
                  },
                  [_vm._v("-")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.doAdd(i)
                      },
                    },
                  },
                  [_vm._v("+")]
                ),
              ]
            ),
          ]),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "invalid-feedback",
          class: { "d-block": !_vm.allInputsValid },
        },
        [
          _vm._v(
            "\n        Bitte geben Sie die Telefonnummer im internationalen Format +49xxxxx "
          ),
          _c("em", [_vm._v("ohne Leerstellen")]),
          _vm._v(" ein.\n    "),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }